function customCursor() {

    const cursor = document.querySelector(".cursor");
    const body = document.body;
    const slider = document.querySelector(".slider");
    const nav = document.querySelector(".nav");
    const fail = document.querySelector(".fail");
    const navOpenMenu = document.querySelector(".navopen");
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    function cursorMove() {
		
        cursor.style.transform = `matrix(1, 0, 0, 1, ${windowWidth / 2}, ${windowHeight / 2})`;

        window.addEventListener("mousemove", (e) => {
            const x = e.clientX;
            const y = e.clientY;

            cursor.style.transform = `matrix(1, 0, 0, 1, ${x}, ${y})`;

            if (nav && !nav.classList.contains("overlay-visible")) {
                const n = Math.floor((x - 60) / 5);
                const t = Math.floor((y - 60) / 5);

                if (n < 20 && t < 20) {
                    navOpenMenu.classList.add("magnetize");
                    navOpenMenu.style.transform = `scale(1.3) translate3d(${n}px, ${t}px, 0)`;
                } else {
                    navOpenMenu.classList.remove("magnetize");
                    navOpenMenu.style.transform = "";
                }
            }
        });
    }

    function cursorBind() {

		// console.log("cursorBind");

        const cursorSpan = cursor.querySelector("span");

        // Active cursor
        window.addEventListener("mouseenter", () => {
            cursorSpan.classList.remove("off");
        });

        window.addEventListener("mouseleave", () => {
            cursorSpan.classList.add("off");
        });

        // Links, buttons, and inputs
        // const interactiveElements = document.querySelectorAll(
        //     "a:not(.link--readmore, .link--viewall, .link--without), button, input, input[type=submit], label"
        // );

        // interactiveElements.forEach((element) => {
        //     element.addEventListener("mouseenter", () => {
        //         body.classList.add("cursor-on");
        //         const cursorClass = element.classList.contains("external") ? "link external" : "link";
        //         cursorSpan.classList.add(cursorClass);
        //     });

        //     element.addEventListener("mouseleave", () => {
        //         body.classList.remove("cursor-on");
        //         cursorSpan.classList.remove("link", "external");
        //     });
        // });

        // Custom link interactions
        const customLinks = [
            { selector: ".link--readmore", className: "cursor--readmore" },
            { selector: ".link--viewall", className: "cursor--viewall" },
            { selector: ".link--play", className: "cursor--play" },
            { selector: ".link--pause", className: "cursor--pause" },
            { selector: ".link--drag", className: "cursor--drag" },
        ];

        customLinks.forEach(({ selector, className }) => {
            const elements = document.querySelectorAll(selector);
            elements.forEach((element) => {
                element.addEventListener("mouseenter", () => {
                    body.classList.add("cursor-on");
                    cursorSpan.classList.add(className);
                });

                element.addEventListener("mouseleave", () => {
                    body.classList.remove("cursor-on");
                    cursorSpan.classList.remove(className);
                });
            });
        });

        // Slider interactions
        if (slider) {
            slider.addEventListener("mouseenter", () => {
                const cursorClass = slider.classList.contains("full") ? "click" : "drag";
                cursorSpan.classList.add(cursorClass);
            });

            slider.addEventListener("mouseleave", () => {
                cursorSpan.classList.remove("drag", "click");
            });
        }

        // Fail interactions
        if (fail) {
            fail.addEventListener("mouseover", () => {
                cursorSpan.classList.add("relol");
            });

            fail.addEventListener("mouseleave", () => {
                cursorSpan.classList.remove("relol");
            });
        }
    }

    // Detect touch devices
    function isTouchDevice() {
        return (
            "ontouchstart" in window ||
            navigator.maxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0
        );
    }

    const isTouch = isTouchDevice();

    if (!isTouch) {
        cursorMove();
        cursorBind();
    }
}

export default customCursor;